<lib-dba-mat-dialog-title (cancelClick)="Abbrechen()">
  {{Title}}
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="FormGroup">
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

  <lib-select-create formControlName="debitorControl" [selectList]="debitorList" selectValue="DebitorID"
    [selectNameList]="['Nummer','Name','PLZ','Ort','LandName']" [label]="language.debitor | translationPipe"
    [showDeselect]="false" [showCreate]="false">
  </lib-select-create>

  <lib-select-create formControlName="standortControl" [selectList]="getfilterStandortList()" selectValue="StandortID"
    [selectNameList]="['Bezeichnung']"  [showCreate]="permissionService.StandortSchreiben && FormGroup.controls['debitorControl'].value != null" 
    [createCallbackFunction]="OpenCreateStandortDialog"  [label]="language.Standort | translationPipe"
    [showDeselect]="true"  [(value)]="selectedstandortModelView" [required]="true">
  </lib-select-create>

  <lib-select-create formControlName="objektControl" [selectList]="getfilterObjektList()" selectValue="ObjektID"
    [selectNameList]="['Bezeichnung']"  [showCreate]="permissionService.ObjektSchreiben && FormGroup.controls['standortControl'].value != null"  
    [createCallbackFunction]="OpenCreateObjektDialog" 
    [label]="language.objekt | translationPipe" [showDeselect]="false" [showCreate]="false" [required]="true">
  </lib-select-create>

  <lib-select-create formControlName="roofareaControl" [selectList]="getfilterRoofareaList()" selectValue="RoofareaID"
    [selectNameList]="['Bezeichnung']" [label]="language.roofarea | translationPipe"
    [showDeselect]="false" [showCreate]="false">
  </lib-select-create>

  <mat-form-field>
    <mat-label>{{language.Bezeichnung | translationPipe}}</mat-label>
    <input matInput maxlength="100" formControlName="bezeichnungControl">
  </mat-form-field>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="Abbrechen()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>